import React from 'react';

const Testimonials = ({ data, onNavigate }) => {

    const handleBookConsultation = () => {
        console.log('Here', onNavigate);
        if (onNavigate) {
            onNavigate('contact');
        }
    };


    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, i) => (
            <svg
                key={i}
                className={`w-5 h-5 ${i < rating ? 'text-amber-400' : 'text-stone-300'}`}
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
        ));
    };

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-stone-800 mb-6">
                        Client Testimonials
                    </h2>
                    <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed">
                        Hear from clients who have found healing and growth through our therapeutic services.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {data.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="bg-stone-50 rounded-2xl p-8 relative"
                        >
                            {/* Quote Icon */}
                            <div className="absolute top-6 right-6">
                                <svg className="w-8 h-8 text-stone-300" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                                </svg>
                            </div>

                            <div className="mb-6">
                                <div className="flex mb-4">
                                    {renderStars(testimonial.rating)}
                                </div>
                                <p className="text-stone-700 leading-relaxed text-lg mb-6">
                                    "{testimonial.text}"
                                </p>
                            </div>

                            <div className="flex items-center">
                                <div className="w-12 h-12 bg-stone-300 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-6 h-6 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-stone-800">{testimonial.name}</h4>
                                    <p className="text-stone-500 text-sm">Verified Client</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Call to Action */}
                <div className="mt-16 text-center bg-gradient-to-r from-stone-50 to-amber-50/30 rounded-2xl p-12">
                    <h3 className="text-2xl sm:text-3xl font-light text-stone-800 mb-6">
                        Ready to Start Your Journey?
                    </h3>
                    <p className="text-stone-600 mb-8 max-w-2xl mx-auto leading-relaxed">
                        Take the first step towards positive change. Schedule a consultation to discuss how we can work together.
                    </p>
                    <button onClick={handleBookConsultation} className="bg-stone-800 text-white px-8 py-4 rounded-lg font-medium hover:bg-stone-700 transition-colors duration-200 shadow-sm">
                        Schedule Consultation
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;